/* ============================================================
   カート用 分割払いシミュレーション
   - cart.total_price（円）から、選択回数に応じた月々を算出
   - 月々 = ceil((合計 + 手数料) / 回数)、手数料 = 合計 × (率/100)
   - 数量変更で .js-contents が再描画されるため、イベント委譲＋cartUpdate購読で再計算
   ============================================================ */
(function () {
  'use strict';

  // 100円あたりの分割払手数料（商品ページのバーと同一の標準表）
  var FEE_PER_100 = {
    3: 2.04, 5: 3.40, 6: 4.08, 10: 6.80, 12: 8.16,
    15: 10.20, 18: 12.24, 20: 13.60, 24: 16.32
  };

  var selectedMonths = 24;

  function yen(n) { return Math.round(n).toLocaleString('ja-JP'); }

  function calcMonthly(total, months) {
    var rate = FEE_PER_100[months];
    if (!rate || total <= 0) return 0;
    var fee = total * (rate / 100);
    return Math.ceil((total + fee) / months);
  }

  function recalc() {
    var box = document.querySelector('[data-installment-cart]');
    if (!box) return;
    var sel = box.querySelector('[data-ibc-select]');
    var out = box.querySelector('[data-ibc-monthly]');
    if (sel) {
      if (sel.value) selectedMonths = parseInt(sel.value, 10) || selectedMonths;
      else sel.value = String(selectedMonths);
    }
    var total = parseInt(box.dataset.cartTotal, 10) || 0;
    var monthly = calcMonthly(total, selectedMonths);
    if (out) out.textContent = monthly > 0 ? yen(monthly) + '円' : '—';
  }

  // 回数変更（イベント委譲：.js-contents 再描画後も有効）
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ibc-select]')) {
      selectedMonths = parseInt(t.value, 10) || selectedMonths;
      recalc();
    }
  });

  // カート更新後：再描画でselectが初期化されるため選択回数を復元して再計算
  function onCartUpdate() {
    var box = document.querySelector('[data-installment-cart]');
    if (box) {
      var sel = box.querySelector('[data-ibc-select]');
      if (sel) sel.value = String(selectedMonths);
    }
    recalc();
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(onCartUpdate, 50); }); } catch (e) { /* ignore */ }
  }

  function boot() { recalc(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
